/* MASONTEX · Media Core — capabilities.js (flat asset path)
   Product capability derivation, DOM-free.
   Replaces model-hardcoded rules (no model === 298) with data-driven lookups. */
(function (global) {
  'use strict';

  const api = (global.MasontexMediaCore = global.MasontexMediaCore || {});
  const capabilities = {};

  capabilities.hasVisor = (lists) => !!(lists.visors && lists.visors.length);

  capabilities.hasOverlays = (config) => !!(config.overlays && Object.keys(config.overlays).length);

  /* Smoke overlay parity rule — replicates the legacy specialSmokeOverlay
     exactly (no redesign). Fires only for the shipped blueGraphic/smoke/
     closed/threeQuarter combination and reads the overlay URL from
     config.overlays.blueGraphic.closed.threeQuarter.silver. */
  capabilities.overlayFor = (ctx, color, visor, structure, view) => {
    if (color !== 'blueGraphic' || visor !== 'smoke' || structure !== 'closed' || view !== 'threeQuarter') return null;
    const silver = ctx.config?.overlays?.blueGraphic?.closed?.threeQuarter?.silver;
    if (!silver) return null;
    return {
      url: api.normalize.extractBase(silver) || silver,
      filter: 'grayscale(1) brightness(.30) contrast(1.22) saturate(.25)'
    };
  };

  capabilities.modelCapabilities = (ctx) => {
    const n = api.normalize;
    const baseDirections = Array.isArray(ctx.config.baseDirections)
      ? ctx.config.baseDirections.length
      : ctx.config.baseDirections
        ? Object.keys(ctx.config.baseDirections).length
        : 0;
    return {
      colors: ctx.lists.colors.length,
      views: ctx.lists.views.length,
      structures: ctx.lists.structures.length,
      visors: ctx.lists.visors.length,
      overlays: capabilities.hasOverlays(ctx.config),
      baseDirections
    };
  };

  capabilities.capabilityMatrix = (ctx) => {
    const n = api.normalize;
    const r = api.resolver;
    return ctx.lists.structures.map((structure) => {
      const structureKey = n.itemKey(structure);
      return ctx.lists.views.map((view) => ({
        structure: structureKey,
        view: n.itemKey(view),
        supported: r.supportedView(ctx, structureKey, n.itemKey(view))
      }));
    });
  };

  api.capabilities = capabilities;
})(typeof window !== 'undefined' ? window : globalThis);
